function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.49976C4.5 5.89758 4.65804 6.27911 4.93934 6.56042C5.22064 6.84172 5.60218 6.99976 6 6.99976C6.39782 6.99976 6.77936 6.84172 7.06066 6.56042C7.34196 6.27911 7.5 5.89758 7.5 5.49976C7.5 5.10193 7.34196 4.7204 7.06066 4.4391C6.77936 4.15779 6.39782 3.99976 6 3.99976C5.60218 3.99976 5.22064 4.15779 4.93934 4.4391C4.65804 4.7204 4.5 5.10193 4.5 5.49976Z",
    stroke: "#667085",
    style: {
      stroke: "#667085",
      stroke: "color(display-p3 0.4009 0.4408 0.5207)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8285 8.32835L6.707 10.4499C6.51949 10.6372 6.26529 10.7424 6.00025 10.7424C5.73521 10.7424 5.48101 10.6372 5.2935 10.4499L3.1715 8.32835C2.61211 7.76894 2.23117 7.0562 2.07685 6.28029C1.92252 5.50437 2.00175 4.70011 2.3045 3.96922C2.60726 3.23833 3.11995 2.61362 3.77774 2.17411C4.43553 1.73459 5.20889 1.5 6 1.5C6.79112 1.5 7.56447 1.73459 8.22226 2.17411C8.88005 2.61362 9.39274 3.23833 9.6955 3.96922C9.99826 4.70011 10.0775 5.50437 9.92316 6.28029C9.76883 7.0562 9.38789 7.76894 8.8285 8.32835Z",
    stroke: "#667085",
    style: {
      stroke: "#667085",
      stroke: "color(display-p3 0.4009 0.4408 0.5207)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.284934cf77f9c906b7bd0f31aa2f9ccb.svg";
export { ForwardRef as ReactComponent };